export default {
  version: 'rc',
  compilation: '240814'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1474
// module chunks = 22